<div *ngIf="caseTitle == typeIrops.CANCELED"> <!-- srIropsCtrl.titulo.caso == 1 -->
  {{ "srIrops.yourItineraryCancelled" | translate }}
</div>
<div *ngIf="caseTitle == typeIrops.DELAYED">
  {{ "srIrops.yourItineraryModify" | translate }}
</div>